import React from 'react';

import { isEqual, noop } from 'lodash';
import { bool, func, shape, string } from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as googleTranslateActions from 'actions/googleTranslate';
import DesktopAppBarV2 from 'components/Common/LayoutV2/AppBar/DesktopV2';
import MobileAppbar from 'components/Common/LayoutV2/AppBar/MobileAppbar';
import withUserType from 'containers/withUserType';

@withUserType
@connect(
  ({
    googleTranslate: { showGoogleTranslate },
    user: { profilePic, email, firstName, lastName, moduleAccess },
  }) => ({
    profilePic: profilePic ? `${profilePic}` : undefined,
    email,
    firstName,
    lastName,
    showGoogleTranslate,
    moduleAccess,
  }),
  d => bindActionCreators(googleTranslateActions, d),
)
export default class AppBar extends React.Component {
  shouldComponentUpdate(nextProps, nextStates) {
    return !isEqual(nextProps, this.props) || !isEqual(nextStates, this.state);
  }

  render() {
    const {
      user,
      email,
      sideNav,
      isDesktop,
      toggleAppbar,
      responsive,
      ...restProps
    } = this.props;

    const showMobileAppbar = !isDesktop;

    return (
      <div>
        {showMobileAppbar ? (
          <MobileAppbar
            {...{ sideNav, toggleAppbar, user, email, ...restProps }}
          />
        ) : (
          <DesktopAppBarV2 {...restProps} />
        )}
      </div>
    );
  }
}

AppBar.propTypes = {
  appBarPageDetails: shape({}),
  color: string,
  email: string,
  firstName: string,
  isDesktop: bool,
  isOnboarding: bool,
  lastName: string,
  moduleAccess: shape({}),
  profilePic: string,
  responsive: bool,
  showBackButton: bool,
  showGoogleTranslate: bool,
  sideNav: bool,
  toggleAppbar: func,
  toggleGoogleTranslate: func,
  user: shape({}),
  hasSubNav: bool,
};

AppBar.defaultProps = {
  appBarPageDetails: null,
  color: null,
  email: null,
  firstName: null,
  isOnboarding: false,
  lastName: null,
  moduleAccess: null,
  profilePic: null,
  showBackButton: false,
  showGoogleTranslate: false,
  sideNav: false,
  toggleAppbar: noop,
  toggleGoogleTranslate: noop,
  user: null,
  isDesktop: false,
  responsive: false,
  hasSubNav: false,
};
